var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeriodicTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor;}.cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.59,145.08l0-.61c0-.68-.08-1.54-.11-2.38-.11-3.25-.65-6.36-3.5-7.71,2.15-.77,4.21-2.4,4.21-6.27,0-5.9-3.74-9.15-10.54-9.15h-10.1a.55.55,0,0,0-.55.55v28.83a.56.56,0,0,0,.55.56h6.42a.56.56,0,0,0,.56-.56V137.52h2.26c2,0,2.89.91,2.93,3,0,.67,0,1.51,0,2.31s0,1.74,0,2.23c.12,1.44.38,3,1.36,3.7a.52.52,0,0,0,.32.11h6.64a.55.55,0,0,0,.52-.36.54.54,0,0,0-.14-.6A5.61,5.61,0,0,1,163.59,145.08Zm-7.15-16.94c0,2.55-1.12,3.54-4,3.54h-2v-7.19h1.21C154.88,124.49,156.44,125.69,156.44,128.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.59,125.83a7.51,7.51,0,0,0-6.31,2.7v-9a.55.55,0,0,0-.56-.55h-6a.54.54,0,0,0-.55.55v28.83a.55.55,0,0,0,.55.56H176a.56.56,0,0,0,.55-.56V137.15c0-2.64.57-5.79,3.31-5.79,1.9,0,2.45.51,2.45,3.84v13.14a.56.56,0,0,0,.56.56H189a.55.55,0,0,0,.55-.56v-15.8C189.56,128.15,187.15,125.83,182.59,125.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.63,
    y: 130.96,
    width: 42.85,
    height: 42.85,
    rx: 9.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.74,162.83H87.13a3.67,3.67,0,0,1-3.66-3.66V152"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.39,
    y: 130.96,
    width: 42.85,
    height: 42.85,
    rx: 9.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.5,162.83H29.88a3.67,3.67,0,0,1-3.66-3.66V152"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.39,
    y: 73.71,
    width: 42.85,
    height: 42.85,
    rx: 9.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.5,105.58H29.88a3.67,3.67,0,0,1-3.66-3.66V94.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 127.81,
    y: 96.54,
    width: 76.4,
    height: 76.4,
    rx: 9.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.15,61.28h-17a.56.56,0,0,0-.56.55V90.67a.56.56,0,0,0,.56.55h6.34a.56.56,0,0,0,.56-.55V79.21h9.17a.56.56,0,0,0,.55-.56V73.73a.55.55,0,0,0-.55-.55H97V66.93h10.11a.55.55,0,0,0,.55-.55V61.83A.55.55,0,0,0,107.15,61.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.58,83.88a.56.56,0,0,0-.51-.45l-5.63-.38a.62.62,0,0,0-.42.15.57.57,0,0,0-.17.41s0,.49,0,.82c0,.52-.15,2.11-3.09,2.11a3.11,3.11,0,0,1-2.29-.89,6,6,0,0,1-1.32-4h12.62a.55.55,0,0,0,.55-.48,16.64,16.64,0,0,0,0-4c-.48-5.93-4-9.33-9.67-9.33-5.14,0-10.62,3.23-10.62,12.3,0,7.62,3.6,11.48,10.69,11.48,7.45,0,9.73-4,9.9-6.37A5.21,5.21,0,0,0,129.58,83.88Zm-10-10.76c1.68,0,2.61.92,2.91,2.87a.13.13,0,0,0,0,.06,4.37,4.37,0,0,1,.11,1h-6.45C116.51,73.59,118.15,73.12,119.57,73.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.16,116.56h-46a9.3,9.3,0,0,1-9.28-9.27V49.43a9.3,9.3,0,0,1,9.28-9.27H139a9.3,9.3,0,0,1,9.28,9.27V94.82"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriodicTable);
export default __webpack_public_path__ + "static/media/PERIODIC_TABLE.56dc9c5b308a73d468db475c4a815f82.svg";
export { ForwardRef as ReactComponent };